import React, { useEffect, useRef, useState } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css';
import { translate } from '../Services/translation';

function ScrollNavButton({ arrowDirection, onClick, show, className = '', ariaLabel }) {
    if (!show) {
        return null;
    }

    return (
        <button
            type="button"
            className={(`slick-arrow slick-${arrowDirection} ` + className).trim() + ' d-none large:d-block'}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.11572 11L6.88461 6L1.11572 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </button>
    );
}

const ItemScroll = ({ items }) => {
    const length = items.length;
    const [sliderItems, setSliderItems] = useState(items);
    const [showPrevArrow, setShowPrevArrow] = useState(false);
    const [showNextArrow, setShowNextArrow] = useState(true);
    const [countShort, setCountShort] = useState(false);
    const resizeTimeoutRef = useRef(0);
    const sliderRef = useRef(null);
    const sliderContainerRef = useRef(null);

    const responsiveConfig = [
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 750,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1140,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 2500,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 10000,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        }
    ];

    const onInit = function() {
        setShowPrevArrow(false);
        setCountShort(sliderItems.length < this.slidesToShow);
    }

    const afterChange = function(current) {
        if (!sliderRef.current) {
            return;
        }

        let currentBreakpoint = sliderRef.current.state.breakpoint;
        if (!currentBreakpoint) {
            currentBreakpoint = 2500;
        }

        let breakpointConfig = responsiveConfig.find(x => x.breakpoint === currentBreakpoint);

        setShowPrevArrow(current > 0);
        setShowNextArrow(current < sliderItems.length - breakpointConfig.settings.slidesToShow);
    }

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        touchMove: true,
        arrows: true,
        prevArrow: <ScrollNavButton arrowDirection="left" show={showPrevArrow} ariaLabel={translate('muha.scroll.previous')} />,
        nextArrow: <ScrollNavButton arrowDirection="right" show={showNextArrow} ariaLabel={translate('muha.scroll.next')} />,
        rtl: false,
        rows: 1,
        centerMode: false,
        centerModePadding: "",
        mobileFirst: true,
        onInit,
        afterChange,
        responsive: responsiveConfig,
        className: "item-scroll__products " + (countShort ? "disable-extra-padding" : "")
    }

    const recalculateHeightVariable = (ref) => {
        let tallestCard = 0;
        let cardItems = sliderContainerRef.current.querySelectorAll('.product-card');

        cardItems.forEach((item, index) => {
            const itemHeight = item.getBoundingClientRect().height;
            tallestCard = itemHeight > tallestCard ? itemHeight : tallestCard;
        });

        setTimeout(() => {
            if (tallestCard) {
                ref.current.firstChild.style.setProperty('--slick-card-height', Math.ceil(tallestCard) + 'px');
            }
        }, 100);
    }

    const handleResize = () => {
        sliderContainerRef.current.firstChild.style.removeProperty('--slick-card-height');

        if (resizeTimeoutRef.current) {
            clearTimeout(resizeTimeoutRef.current);
        }

        resizeTimeoutRef.current = setTimeout(() => {
            recalculateHeightVariable(sliderContainerRef);
        }, 250);
    };

    useEffect(() => {
        if (sliderRef.current && sliderContainerRef.current) {
            recalculateHeightVariable(sliderContainerRef);
            window.addEventListener('resize', handleResize);
        }

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div ref={sliderContainerRef}>
            <Slider {...settings} ref={sliderRef}>
                {sliderItems.map((item, index) => {
                    return (
                        <div key={"item-scroll-" + index} dangerouslySetInnerHTML={{
                            __html: item.html,
                        }} className={item.className || null}></div>
                    )
                })}
            </Slider>
        </div>
    );
}

export default ItemScroll
